





















































































































































































































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import _, { property } from 'lodash';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Users from '@/store/modules/Users';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import BasicInputForm from '@/components/forms/BasicInputForm.vue';
import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import { Viewpoint } from '@/api/model/Viewpoint';
import { NotificationEventBus } from '@/EventBus';
import Choices, { Choice } from '@/store/modules/Choices';
import ViewpointVisibilityDialog from '@/components/workspace-options/ViewpointVisibilityDialog.vue';
import { Urls } from '@/Urls';
import ChoiceInputDialog from '@/components/choice-input/ChoiceInputDialog.vue'
import CreateChoiceDialog from '@/views/ChoiceCards/CreateChoiceDialog.vue';
import ExportPreview from "@/views/FileExport/ExportPreview.vue"

const usersModule = getModule(Users);
const decisionsModule = getModule(Decisions);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);

@Component({
    components: {
        ConfirmationDialog,
        ViewpointVisibilityDialog,
        BasicInputForm,
        ChoiceInputDialog,
        CreateChoiceDialog,
        ExportPreview
    },
    directives: {},
})
export default class ChoiceViewpointCommonMenu extends Vue {
    @Prop({
        default: () => {
            return {};
        },
        type: Object,
    })
    item!: any;

    @Prop({ default: false, type: Boolean})
    isChoiceCard!: false;

    @Prop({ default: false, type: Boolean})
    isDialog!: false;
    
    @Prop({default:false,type: Boolean})
    noCreateBtn!: boolean;

    @Prop({default: true, type: Boolean})
    addToList!: boolean;

    @Prop({default: false, type: Boolean})
    isChoiceSelection!: boolean;

    @Prop({default: false, type: Boolean})
    isChoiceSubmitter!: boolean;

    @Prop({default: false, type: Boolean})
    isViewpointSelection!: boolean;

    private cloneChoiceDialog = false;
    private originalChoice: any = {};
    private menuShow: boolean = false;
    private createViewpointDialog = false;
    private adding = false;
    private editViewpointDialog = false;
    private formViewpoint = {};
    private cloneViewpointDialog = false;
    private originalViewpoint: any = {};
    private visibilityEditViewpointId = '';
    private createChoiceDialog = false;
    private choiceForm = {};
    private renameChoiceDialog = false; 
    get currentUserId() {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
    }
    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get activeChoiceLists() {
        return workspaceOptionsModule.activeChoiceLists || [];
    }

    get choiceIds() {
        return choicesModule.choiceIds;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get activeViewpointList() {
        return workspaceOptionsModule.activeViewpointLists;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get editContent() {
        return workspaceOptionsModule.editContent;
    }

    private async createViewpoint(viewpoint: any) {
        if (!this.selectedDecision) return;
        this.adding = true;
        let sampleViewpoint = _.cloneDeep(viewpoint);
        NotificationEventBus.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            let res = await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description
            });
            if (
                sampleViewpoint.addToList &&
                this.activeViewpointList?.length > 0 &&
                this.addToList
            ) {
                decisionsModule.addViewpointToActiveLists(res.viewpointId);
            }
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
        this.adding = false;
    }

    private async copyChoice(choice: any) {
        this.cloneChoiceDialog = false;
        await choicesModule.copyChoice({ choice: this.originalChoice, newChoiceParams: choice });
    }

    private async deleteChoice(choiceId: string) {
        NotificationEventBus.emitProcessingMessage();
        try {
            await choicesModule.deleteChoice(choiceId);
            if (this.choiceIds && this.choiceIds.length > 0) {
                for (let item of this.choiceIds) {
                    if (item !== choiceId) {
                        choicesModule.selectChoice(item);
                        break;
                    }
                }
            }
            this.menuShow = false;
            NotificationEventBus.emitSuccessMessage();
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e);
        }
    }

    private canUserDelete(choice: any) {
        let usersModule = getModule(Users);

        //Owner of decision can always delete choices
        if (
            decisionsModule.selectedDecision.ownerUserId === usersModule.currentUserProfile.userId
        ) {
            return true;
        }

        if (choice && choice.ownerUserId === usersModule.currentUserProfile.userId) {
            return true;
        }

        if( decisionsModule.isAdmin) {
            return true;
        }

        //Reaching here means user is not owner of choice or decision
        return !['VIEW', 'EDIT'].includes(choice.shareSetting);
    }

    saveChoiceName(choiceName: string) {
        NotificationEventBus.emitProcessingMessage();
        if (choiceName != '') {
            this.choiceForm = {};
            let newChoice: any = {name: choiceName};
            choicesModule
                .createChoice(newChoice)
                .then((result) => {
                    console.log('createChoice Result');
                    console.log(result);
                    choicesModule.selectChoice(result.id);
                    if(this.activeChoiceLists?.length > 0) {
                        decisionsModule.addChoiceToActiveLists(result.id)
                        choicesModule.fetchChoices()
                    }
                    NotificationEventBus.emitSuccessMessage();
                    NotificationEventBus.emitStaleSandboxScoringData('');
                })
                .catch((err) => {
                    NotificationEventBus.emitFailedMessage(err);
                });
            this.createChoiceDialog = false;
        }
    }
    private createNewChoice() {
       // this.cleanChoiceForm = {};
        //choicesModule.selectChoice(null);
        this.createChoiceDialog = true;
    }

    private editChoiceName() {
        this.renameChoiceDialog = true;
    }
    
    // viewpoint edit visibility
    private editVisibilityClick(viewpoint: Viewpoint) {
        this.visibilityEditViewpointId = viewpoint.viewpointId;
        // getModule(Dialogs).editViewpointVisibility(viewpoint.viewpointId);
    }

    // open edit viewpoint dialog
    private editViewpointClick(viewpoint: Viewpoint) {
        this.formViewpoint = viewpoint;
        this.editViewpointDialog = true;
    }
    //  update viewpoint
    private async editViewpoint(payload: Viewpoint) {
        this.editViewpointDialog = false;
        NotificationEventBus.emitProcessingMessage();
        try {
            await decisionsModule.updateViewpoint(payload);
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    // open clone viewpoint dialog
    private setOriginalViewpoint(viewpoint: Viewpoint) {
        this.originalViewpoint = _.cloneDeep(viewpoint);
        console.log(this.originalViewpoint);
        this.cloneViewpointDialog = true;
    }
    // clone viewpoint 
    private async cloneViewpoint(payload: any) {
        this.cloneViewpointDialog = false;
        if (!this.selectedDecision) return;
        NotificationEventBus.emitProcessingMessage();
        let original: Viewpoint = _.cloneDeep(this.originalViewpoint);
        let newParams = _.cloneDeep(payload);
        // console.log(newParams);
        // console.log(original);
        try {
            await viewpointsModule.cloneViewpoint({ original: original, newViewpoint: newParams, includeWeights: true, includeKeys: true, includeScores: true });
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private async renameChoice(choiceName: string) {
        // NotificationEventBus.emitProcessingMessage();
        if (choiceName != '') {
            choicesModule.renameChoice({newName:choiceName, choice: this.item});
            // NotificationEventBus.emitSuccessMessage();
            
        }
        this.renameChoiceDialog = false;
    }
}
